// Comment form validation
import scrollObserver from '../../util/scrollObserver';

function validateField(field, fieldStr)
{

    if (field !== null && field !== undefined) {
        var fieldName = field.id,
            fieldError = document.querySelector('.'+fieldName+'-error'),
            fieldVal = field.value;

        if (fieldVal === '') {
            if (fieldError === null) {
                throwFormError(field, 'Please enter a value.');

                return false;
            }
        } else if (fieldStr == 'email' && !validateEmail(fieldVal)) {
            if (fieldError === null) {
                throwFormError(field, 'This email is not valid');

                return false;
            }
        } else {
            if (fieldError) {
                field.classList.remove('invalid');
                fieldError.remove();
            }

            return true;
        }
    }

}

function throwFormError(field, error)
{
    var errorDiv = document.createElement('div');

    errorDiv.className = field.id+'-error error';
    errorDiv.innerText = error;

    field.classList.add('invalid');
    field.parentNode.insertBefore(errorDiv, field);
}

function validateEmail(email)
{
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validate()
{

    var form = document.getElementById('commentform');

    if (form !== undefined && form !== null) {
        form.addEventListener('submit', function (e) {

            var invalid = false,
                fields = [
                    'author',
                    'comment',
                    'email',
                ];

            for (let field of fields) {
                var fieldQuery = form.querySelector('#'+field);

                var valid = validateField(fieldQuery, field);

                if (!valid && fieldQuery !== undefined) {
                    invalid = true;
                }
            }

            if (invalid) {
                e.preventDefault();
                e.stopImmediatePropagation();

                return false;
            }

            return false;

        });
    }

}

function loadCommentReply()
{

    const commentContainer = document.getElementsByClassName('comments-container');
    let hasLoadedComment = false;

    scrollObserver('.comments-container', () => {
        if (!hasLoadedComment && commentContainer) {
            hasLoadedComment = true;
            var s = document.createElement('script'),
                e = !document.body ? document.querySelector('head') : document.body;
            s.src = window.site_settings.site_root+'/wp-includes/js/comment-reply.min.js';
            s.async = s.defer = true;
            e.appendChild(s);
        }
    });
}

function commentAccordion()
{
    const collapse = document.getElementsByClassName('comments-title');
    let i;

    if (collapse) {
        for (i = 0; i < collapse.length; i++) {
            collapse[i].addEventListener('click', function () {
                this.classList.toggle('active');
                var content = this.nextElementSibling;
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
            })
        }
    }
}

export default function init()
{

    validate();
    loadCommentReply();
    commentAccordion();

}
